var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 37,
    viewBox: "0 0 34 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.00879283 18.4987C0.00879283 15.965 0.0275687 13.4312 0.000258341 10.8975C-0.0133968 9.62473 0.517448 8.73666 1.644 8.11451C6.25092 5.57239 10.8476 3.01354 15.4391 0.444662C16.4991 -0.149057 17.5045 -0.147384 18.5645 0.444662C23.156 3.01354 27.7527 5.57239 32.3596 8.11451C33.4862 8.73666 34.0051 9.62808 34 10.9008C33.9795 15.9683 33.9795 21.0342 34 26.1017C34.0051 27.3744 33.4828 28.2642 32.3562 28.8863C27.751 31.4301 23.1526 33.9873 18.5611 36.5562C17.5011 37.1499 16.494 37.1465 15.4357 36.5545C10.8442 33.9856 6.24751 31.4268 1.64059 28.8846C0.514035 28.2625 -0.0133968 27.3728 0.000258341 26.1C0.0275687 23.5646 0.00879283 21.0308 0.00879283 18.4987Z",
    fill: "url(#paint0_linear_888_2808)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_888_2808",
    x1: 33.2681,
    y1: 30.4859,
    x2: 0.415581,
    y2: 8.92998,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.128199,
    stopColor: "#FFDBB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.942149,
    stopColor: "#FFF4D7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.ea2b08fe77589199510ed247910829d0.svg";
export { ForwardRef as ReactComponent };